document.addEventListener('alpine:init', () => {
  Alpine.data('gbiTikTokBanner', () => ({
    isVisible: false,
    isMobile: false,
    _io: null,
    _resize: null,
    _sectionUnload: null,

    init() {
      const self = this;
      this.checkMobile();

      this._resize = function () { self.checkMobile(); };
      window.addEventListener('resize', this._resize, { passive: true });

      this._io = new IntersectionObserver(function (entries) {
        if (entries[0] && entries[0].isIntersecting) {
          self.isVisible = true;
          self._io.disconnect();
        }
      }, { threshold: 0.2 });
      this._io.observe(this.$el);

      this._sectionUnload = function (e) {
        if (self.$el && self.$el.closest('.shopify-section') === e.target) {
          self.destroy();
        }
      };
      document.addEventListener('shopify:section:unload', this._sectionUnload);
    },

    checkMobile() {
      this.isMobile = window.innerWidth < 768;
    },

    destroy() {
      if (this._io) { this._io.disconnect(); this._io = null; }
      if (this._resize) { window.removeEventListener('resize', this._resize); this._resize = null; }
      if (this._sectionUnload) { document.removeEventListener('shopify:section:unload', this._sectionUnload); this._sectionUnload = null; }
    },
  }));
});
